// extracted by mini-css-extract-plugin
export default {"Button":"button_Button__Wf17r","Xsmall":"button_Xsmall__Kv9-H"};